<div *ngIf='contentInfo' class='EditContent'>
  <div class='EditContent-header'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/campaigns']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'
        >Campaigns</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <a
          [queryParams]='{ index }'
          [routerLink]="['/campaigns', cid, 'preview-content']"
          class='Breadcrumbs-item first'
        >{{ contentInfo.content_template }}</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>{{ contentInfo.content_name }}</span>
      </div>
    </div>
  </div>
  <div class='EditContent-body mt-5 p-5'>
    <div class='d-flex flex-row justify-content-between align-items-center'>
      <h2>Edit Content</h2>
      <b>Select to apply in all Templates</b>
    </div>
    <div class='EditContent-form mt-3 p-5'>
      <form [formGroup]='formGroup'>
        <div class='EditContent-form-row row'>
          <div class='col col-12 col-md-2 d-flex align-items-center'>
            <mat-label>Group Name:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <app-text-field
              [disabled]='true'
              [fieldBackgroundClass]="'white'"
              [value]='contentInfo.content_group'></app-text-field>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-12 col-md-2 d-flex align-items-center'>
            <mat-label>Content Name:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <app-text-field
              [disabled]='true'
              [fieldBackgroundClass]="'white'"
              [value]='contentInfo.content_name'></app-text-field>
          </div>
          <div class='col col-12 col-md-1'></div>
        </div>
        <div class='EditContent-form-row row'>
          <div
            class='EditContent-form-label col col-12 col-md-2 d-flex align-items-center'>
            <mat-label>Subject:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <app-text-field
              [fieldBackgroundClass]="'white'"
              formControlName='subject'></app-text-field>
          </div>
          <div class='col col-12 col-md-1'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_subject'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='EditContent-form-label col col-12 col-md-2'></div>
          <div class='EditContent-form-row-middle col col-12 col-md-3'>
            <mat-form-field *ngIf='showCustomGreeting'>
              <mat-label>Greeting</mat-label>
              <input
                [placeholder]="'Enter Greeting'"
                formControlName='custom_greeting'
                matInput />
            </mat-form-field>
            <app-button
              *ngIf='showCustomGreeting'
              [Click]='backToGreetingsButton.onClick'
              [color]='backToGreetingsButton.color'
              [size]='backToGreetingsButton.size'
              [text]='backToGreetingsButton.text'></app-button>
            <app-select
              (selection)='onGreetingsSelection($event)'
              *ngIf='!showCustomGreeting'
              [colorWhite]='true'
              [defaultValue]='contentInfo.greeting'
              [items]='greetings.items'
              [label]='greetings.label'
              formControlName='greeting'></app-select>
          </div>
        </div>
        <ng-container [ngSwitch]='index.toString()'>
          <ng-container *ngSwitchCase='0'>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Attention:</mat-label>
                <p
                  (click)="insertHyperlink('opening')"
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #attention
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='attention'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, attention)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 01:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit01
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_01'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit01)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 02:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit02
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_02'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit02)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='1'>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Opening:</mat-label>
                <p
                  (click)='insertHyperlink(opening)'
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #opening
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='opening'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, opening)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 02:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit02
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_02'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit02)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Attention:</mat-label>
                <p
                  (click)="insertHyperlink('attention')"
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #attention
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='attention'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, attention)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 01:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit01
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_01'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit01)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='2'>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Opening:</mat-label>
                <p
                  (click)='insertHyperlink(opening)'
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #opening
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='opening'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, opening)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 01:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit01
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_01'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit01)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 02:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit02
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_02'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit02)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='3'>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Opening:</mat-label>
                <p
                  (click)='insertHyperlink(opening)'
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #opening
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='opening'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, opening)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Benefit 01:</mat-label>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #benefit01
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='benefit_01'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, benefit01)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-12 col-md-2'>
                <mat-label>Attention:</mat-label>
                <p
                  (click)="insertHyperlink('attention')"
                  class='EditContent-form-insert_link'>
                  Insert Hyperlink
                </p>
              </div>
              <div class='EditContent-form-row-middle col col-12 col-md-9'>
                <editor #attention
                        [init]='{indent: false,contextmenu: false}'
                        apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                        formControlName='attention'
                        plugins='link lists'
                        plugins='link lists'
                        toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
                <div class='d-flex flex-row'>
                  <div *ngIf='variables.length > 0' class='flex-grow-0'>
                    <app-select
                      (selection)='onVariableSelect($event, attention)'
                      [items]='variables'
                      [label]="'Insert Variable'"></app-select>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-1'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class='EditContent-form-row row'>
          <div class='col col-12 col-md-2'>
            <mat-label>Closing:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <editor #closing
                    [init]='{indent: false,contextmenu: false}'
                    apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                    formControlName='closing'
                    plugins='link lists'
                    plugins='link lists'
                    toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
            <div class='d-flex flex-row'>
              <div *ngIf='variables.length > 0' class='flex-grow-0'>
                <app-select
                  (selection)='onVariableSelect($event, closing)'
                  [items]='variables'
                  [label]="'Insert Variable'"></app-select>
              </div>
            </div>
          </div>
          <div class='col col-12 col-md-1'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_closing'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-12 col-md-2'>
            <mat-label>Signature:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <editor #editor
                    (onInit)='onEditorInit($event)'
                    [init]='{indent: false,contextmenu: false}'
                    apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                    formControlName='signature'
                    plugins='link lists'
                    toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
          </div>
          <div class='col col-12 col-md-1'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_signature'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-12 col-md-2'>
            <mat-label>Detailed Statement:</mat-label>
          </div>
          <div class='EditContent-form-row-middle col col-12 col-md-9'>
            <editor [init]='{indent: false,contextmenu: false}'
                    apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
                    formControlName='details'
                    plugins='link lists'
                    plugins='link lists'
                    toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
          </div>
          <div class='col col-12 col-md-1'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_details'></mat-checkbox>
          </div>
        </div>
      </form>
    </div>
    <div class='EditContent-footer d-flex justify-content-end mt-4'>
      <app-button
        [Click]='cancelButtonProperties.onClick'
        [color]='cancelButtonProperties.color'
        [size]='cancelButtonProperties.size'
        [text]='cancelButtonProperties.text'
        class='EditContent-footer-button'></app-button>
      <app-button
        [Click]='submitButtonProperties.onClick'
        [color]='submitButtonProperties.color'
        [size]='submitButtonProperties.size'
        [text]='submitButtonProperties.text'
        class='EditContent-footer-button'></app-button>
    </div>
  </div>
</div>
